import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Container, Row } from '../../VuexyDesign/atoms/_index';
import BrowserPageTitle from '../common/BrowserPageTitle';
import RenderMetaTags from '../../utils/renderMetaTags';
import DistributeMusicYourTerms from './DistributeMusicYourTerms';
import DistributionStreamingPlatform from './DistributionStreamingPlatform';
import DiscoverBenefits from '../Pricing/DiscoverBenefits';
import Testimonial from '../Pricing/Testimonial';
import DistributionLandingStepsContainer from './DistributionLandingStepsContainer';
import DIstributionCompareChooseUs from './DIstributionCompareChooseUs';
import FriendlyQuestions from './FriendlyQuestions';
import DistributionProInfo from './DistributionProInfo';
import { useIsDesktop } from '../../style/constants';

export const DistributionLandingLayoutPage = () => {
  const { t } = useTranslation('organisms');
  const isDesktop = useIsDesktop();
  return (
    <>
      <Container fluid className="overflow-hidden">
        <BrowserPageTitle
          description={t('distributionLanding:seoDescription') as string}
        >
          {t('distributionLanding:seoTitle') as string}
        </BrowserPageTitle>

        {RenderMetaTags({
          'og:title': `${t('distributionLanding:seoTitle') as string}`,
          'og:image':
            'https://virpp.com/static/images/distribution-landing/title-image-distribution-landing-page.jpeg',
          'og:description': `${
            t('distributionLanding:seoDescription') as string
          }`,
          'og:image:alt': `${t('distributionLanding:seoImageAlt') as string}`,
          'twitter:title': `${t('distributionLanding:seoTitle') as string}`,
          'twitter:image':
            'https://virpp.com/static/images/distribution-landing/title-image-distribution-landing-page.jpeg',
          'twitter:description': `${
            t('distributionLanding:seoDescription') as string
          }`,
        })}
      </Container>
      <div className=" pb-1">
        <DistributeMusicYourTerms />
      </div>
      <div
        className="mt-2 bg-white"
        style={{ paddingBottom: '7rem', paddingTop: '2rem' }}
      >
        <DistributionStreamingPlatform />
      </div>
      <Container className="w-100 mt-3">
        <DiscoverBenefits type="DISTRIBUTION" />
      </Container>

      <div style={{ paddingBottom: '1rem' }} className="relative">
        <Testimonial
          title={t('pricing:titleTestimonial') as string}
          subtitle={t('pricing:subTitleTestimonial') as string}
        />
        <DistributionLandingStepsContainer />
        <div className="mt-5">
          <DIstributionCompareChooseUs />
        </div>
        <Container className={`${isDesktop ? 'w-75' : 'w-100'} mb-3`}>
          <Row
            className={`${
              isDesktop ? '' : 'px-1'
            } mb-2 d-flex justify-content-center`}
          >
            <FriendlyQuestions
              customTitle={
                t('distributionLanding:distributionLandingFAQ') as string
              }
            />
          </Row>
        </Container>
        <Container>
          <DistributionProInfo />
        </Container>
      </div>
    </>
  );
};
